import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { routing }       from './pages.routing';
import { NgaModule } from '../theme/nga.module';
import { AppTranslationModule } from '../app.translation.module';
import { CanActivateViaAuthGuard } from '../theme/guards/canactivate.guard';
import { LocalizationModule } from './localization/localization.module';


import { Pages } from './pages.component';
import {ProjectImagesService} from "../services/project-images.service";


@NgModule({
  imports: [CommonModule, AppTranslationModule, NgaModule,LocalizationModule, routing],
  declarations: [Pages],
  providers:[CanActivateViaAuthGuard]
})
export class PagesModule {
}



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts